import { render, staticRenderFns } from "./custom-toast.vue?vue&type=template&id=20485d46&"
import script from "./custom-toast.vue?vue&type=script&lang=js&"
export * from "./custom-toast.vue?vue&type=script&lang=js&"
import style0 from "./custom-toast.vue?vue&type=style&index=0&id=20485d46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports